module.exports = __webpack_public_path__ + "img/play.4abd90f6.svg";